// extracted by mini-css-extract-plugin
export default {"indicator":"Gallery_indicator__mJh+u","arrow":"Gallery_arrow__WAIAz","slider-image":"Gallery_slider-image__2gQML","buttons":"Gallery_buttons__+T-nn"};